import { GET_ADVERTISEMENT, GET_ADVERTISEMENT_SUCCESS, GET_ADVERTISEMENT_FAILURE } from "../constants"

const INIT_STATE = {
    advertisements: false,
    fetching: false,
    error: false
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ADVERTISEMENT:
            return { ...state, fetching: true, error: false }

        case GET_ADVERTISEMENT_SUCCESS:
            return { ...state, fetching: false, error: false, advertisements: action.payload.advertisements }

        case GET_ADVERTISEMENT_FAILURE:
            return { ...state, fetching: false, error: action.payload.err }

        default:
            return { ...state }
    }
}